/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export const SET_YOUR_PASSWORD_ROUTE_NAME = 'setyourpassword';
export const SUCCESSFULLY_VERIFIED_ROUTE_NAME = 'successfullyverified';
export const VERIFY_YOUR_ACCOUNT_ROUTE_NAME = 'verifyyouraccount';
